/** Available reminder types */
export enum ReminderTypeEnum {
  /** Project personal reminder */
  PROJECT = 'PROJECT',
  /** Project checklist reminder for checklist responsible */
  PROJECT_CHECKLIST = 'PROJECT_CHECKLIST',
  /** Deal personal reminder */
  DEAL = 'DEAL',
  /** Deal event reminder for event responsible */
  DEAL_EVENT = 'DEAL_EVENT',
  /** HelpDesk task reminder */
  HELPDESK = 'HELPDESK',
  /** Debt collection task personal reminder */
  DEBT_COLLECTION_TASK = 'DEBT_COLLECTION_TASK',
  /** Debt collection task event reminder for event responsible */
  DEBT_COLLECTION_TASK_EVENT = 'DEBT_COLLECTION_TASK_EVENT',
}
